/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
// eslint-disable-next-line
import React, { useState, useEffect, useRef } from 'react'; // eslint-disable-next-line
import { copiriAxiosPost, copiriPortalRequest, getFormattedDate } from '../../../api/api'; // eslint-disable-next-line
import config from '../../../config/config'; // eslint-disable-next-line
import { toast } from 'react-toastify';
// eslint-disable-next-line
import FormGroupInput from '../../../common/FormGroupInput';
import { Row, Col, Button, Form } from 'react-bootstrap';
// eslint-disable-next-line
import CopiriLoader from '../../../common/CopiriLoader';
import image_loader from '../../../../assets/img/loader/small_loader.gif'; // eslint-disable-next-line
const CharterField = props => {
	// eslint-disable-next-line
	const { lodgeData, id, closeModal, updateLodgeModal, pageLanguageContent } = props;
	const [date, setDate] = useState('');
	const [formatedDate, setFormatedDate] = useState('');
	const [showLoader, setShowLoader] = useState(false);
	const [validation, setValidation] = useState({
		error_founded: ''
	});
	const options = {
		year: 'numeric',
		month: 'long',
		day: 'numeric'
	};

	useEffect(() => {
		if (props.id) {
			if (lodgeData['founded']) {
				let founded_date = getDate(lodgeData['founded']);
				setDate(founded_date);
				setFormatedDate(getFormattedDate(founded_date));
			} else {
				setDate('');
			}
		}
		// eslint-disable-next-line
	}, [props.id]);


	function getDate(foundedDate) {
		let newdate= '';
		var dateObj = new Date(foundedDate);
		var month = dateObj.getUTCMonth() + 1; //months from 1-12
		var day = dateObj.getUTCDate();
		var year = dateObj.getUTCFullYear();
		if (month < 10) {
			month = '0' + month;
		}
		if (day < 10) {
			day = '0' + day;
		}
		newdate = year + '-' + month + '-' + day;
		return newdate;
	}


	const onChangeDate = event => {
		let founded_date = getDate(event.target.value);
		setDate(founded_date);
		setFormatedDate(getFormattedDate(event.target.value));
	};

	const dateOnlyRegex = /^([0-9]([0-9]([0-9][1-9]|[1-9]0)|[1-9]00)|[1-9]000)(-(0[1-9]|1[0-2])(-(0[1-9]|[1-2][0-9]|3[0-1])))$/;
	function parseDateString(dateString) {
		if (dateOnlyRegex.test(dateString)) {
			const utcDate = new Date(dateString);
			const localDate = new Date(utcDate.getTime() + utcDate.getTimezoneOffset() * 60000);
			return localDate;
		}
		return new Date(dateString);
	}

	function updateData() {
		let errors = { ...validation };
		var errorCount = 0;

		if (date === '') {
			errors.error_founded = pageLanguageContent['CLD071'];
			errorCount++;
		} else {
			errors.error_founded = '';
		}
		var sendData = {};
		let dateObj = parseDateString(date);
		let send_date = dateObj.toLocaleDateString('en-US');
		sendData['founded'] = send_date;
		var returnDate = dateObj.toLocaleDateString('en-US', options);
		setValidation(errors);
		if (errorCount <= 0) {
			setShowLoader(true);
			copiriPortalRequest('/organizations/' + id, config.app_version, 'patch', sendData)
				.then(response => {
					setShowLoader(false);
					if (response.data.status && response.data.status === 'SUCCESS') {
						toast.success(pageLanguageContent['CLD119']);
						closeModal();
						updateLodgeModal('founded', returnDate);
					}
				})
				.catch(error => {
					toast.error(error.response.data.result);
					setShowLoader(false);
				});
		}
	}

	/* function to trigger input file */
	function clickInputFile() {
		document.getElementById('charter_date').click();
	}

	return (
		<Row className='mt-2'>
			<Col lg={12} className='date-input-container'>
				<Form.Label>{pageLanguageContent['CLD022'] ? pageLanguageContent['CLD022'] : ''}</Form.Label>
				<div className='date-input-container'>
					<input
						type='text'
						id='visibleInput'
						placeholder='Select a date'
						readOnly
						value={formatedDate}
						className='form-control'
						style={{ cursor: 'pointer' }}
						onClick={() => clickInputFile()}
					/>
					<input
						type='date'
						className='hidden-date-input form-control'
						value={date}
						onChange={onChangeDate}
						onClick={e => e.currentTarget.showPicker()}
						id='charter_date'
						style={{ cursor: 'pointer' }}
					/>
				</div>
				<i className='far fa-calendar-image charter_date_calendar' onClick={() => clickInputFile()}></i>
			</Col>
			<Col lg={12}>
				<br />
				<Button
					variant='primary'
					id={'confirmValidatebutton'}
					style={{ float: 'right', marginBottom: '15px' }}
					onClick={updateData}
				>
					{showLoader ? (
						<img src={image_loader} alt='loader' height='20' width='20' />
					) : pageLanguageContent['CLD124'] ? (
						pageLanguageContent['CLD124']
					) : (
						''
					)}
				</Button>
			</Col>
		</Row>
	);
};
export default CharterField;
